/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ConfigurationItemDTO } from "./ConfigurationItemDTO";
import {
  ConfigurationItemDTOFromJSON,
  ConfigurationItemDTOFromJSONTyped,
  ConfigurationItemDTOToJSON
} from "./ConfigurationItemDTO";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";
import type { MerchantDTO } from "./MerchantDTO";
import { MerchantDTOFromJSON, MerchantDTOFromJSONTyped, MerchantDTOToJSON } from "./MerchantDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";
import type { ProductDealSortDTO } from "./ProductDealSortDTO";
import {
  ProductDealSortDTOFromJSON,
  ProductDealSortDTOFromJSONTyped,
  ProductDealSortDTOToJSON
} from "./ProductDealSortDTO";

/**
 *
 * @export
 * @interface InExternalDealFilterDTO
 */
export interface InExternalDealFilterDTO {
  /**
   *
   * @type {number}
   * @memberof InExternalDealFilterDTO
   */
  id: number;
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof InExternalDealFilterDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  productFeedUrl?: string;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  lastRunStartDate?: string;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  lastRunEndDate?: string;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  nextRunAtDate?: string;
  /**
   *
   * @type {number}
   * @memberof InExternalDealFilterDTO
   */
  runIntervalSeconds: number;
  /**
   *
   * @type {string}
   * @memberof InExternalDealFilterDTO
   */
  searchQuery?: string;
  /**
   *
   * @type {boolean}
   * @memberof InExternalDealFilterDTO
   */
  live: boolean;
  /**
   *
   * @type {number}
   * @memberof InExternalDealFilterDTO
   */
  productDealLimit: number;
  /**
   *
   * @type {ProductDealSortDTO}
   * @memberof InExternalDealFilterDTO
   */
  productDealSort: ProductDealSortDTO;
  /**
   *
   * @type {Array<ConfigurationItemDTO>}
   * @memberof InExternalDealFilterDTO
   */
  configurations?: Array<ConfigurationItemDTO>;
  /**
   *
   * @type {Array<MerchantDTO>}
   * @memberof InExternalDealFilterDTO
   */
  merchants: Array<MerchantDTO>;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof InExternalDealFilterDTO
   */
  categories?: Array<GenericIdDTO>;
}

/**
 * Check if a given object implements the InExternalDealFilterDTO interface.
 */
export function instanceOfInExternalDealFilterDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "runIntervalSeconds" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "productDealLimit" in value;
  isInstance = isInstance && "productDealSort" in value;
  isInstance = isInstance && "merchants" in value;

  return isInstance;
}

export function InExternalDealFilterDTOFromJSON(json: any): InExternalDealFilterDTO {
  return InExternalDealFilterDTOFromJSONTyped(json, false);
}

export function InExternalDealFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InExternalDealFilterDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    platform: PlatformRefDTOFromJSON(json["platform"]),
    title: json["title"],
    productFeedUrl: !exists(json, "productFeedUrl") ? undefined : json["productFeedUrl"],
    lastRunStartDate: !exists(json, "lastRunStartDate") ? undefined : json["lastRunStartDate"],
    lastRunEndDate: !exists(json, "lastRunEndDate") ? undefined : json["lastRunEndDate"],
    nextRunAtDate: !exists(json, "nextRunAtDate") ? undefined : json["nextRunAtDate"],
    runIntervalSeconds: json["runIntervalSeconds"],
    searchQuery: !exists(json, "searchQuery") ? undefined : json["searchQuery"],
    live: json["live"],
    productDealLimit: json["productDealLimit"],
    productDealSort: ProductDealSortDTOFromJSON(json["productDealSort"]),
    configurations: !exists(json, "configurations")
      ? undefined
      : (json["configurations"] as Array<any>).map(ConfigurationItemDTOFromJSON),
    merchants: (json["merchants"] as Array<any>).map(MerchantDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(GenericIdDTOFromJSON)
  };
}

export function InExternalDealFilterDTOToJSON(value?: InExternalDealFilterDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    platform: PlatformRefDTOToJSON(value.platform),
    title: value.title,
    productFeedUrl: value.productFeedUrl,
    lastRunStartDate: value.lastRunStartDate,
    lastRunEndDate: value.lastRunEndDate,
    nextRunAtDate: value.nextRunAtDate,
    runIntervalSeconds: value.runIntervalSeconds,
    searchQuery: value.searchQuery,
    live: value.live,
    productDealLimit: value.productDealLimit,
    productDealSort: ProductDealSortDTOToJSON(value.productDealSort),
    configurations:
      value.configurations === undefined
        ? undefined
        : (value.configurations as Array<any>).map(ConfigurationItemDTOToJSON),
    merchants: (value.merchants as Array<any>).map(MerchantDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(GenericIdDTOToJSON)
  };
}
